import { filter, difference } from 'lodash';
import { asyncFetchData, asyncPaginatedFetch } from '../../utilities/http-utilities';
import LayoutPosition from '../../models/layout_position';
import Landmark from '../../models/landmark';
import Layout from '../../models/layout';
import LayoutProduct from '../../models/layout_product';
import LayoutSection from '../../models/layout_section';
import RentalPeriod from '../../models/rental_period';
import LayoutSectionSerializer from './layout_section_serializer';

export default class Client {

  constructor(layoutId, destinationId, token) {
    this.layoutId = layoutId;
    this.destinationId = destinationId;
    this.token = token;
    this.API_BASE_URL = '/sandbar/admin';
  }

  async fetchPositions() {
    const positions = await asyncPaginatedFetch(`${this.API_BASE_URL}/layout_positions?layout_id=${this.layoutId}`);
    return positions.map(position => LayoutPosition.fromAttributes(position));
  }

  async fetchRentalPeriods(positions, date, readOnly) {
    if (!readOnly) return [];

    const inventoryUnitIds = positions.map(position => position.inventoryUnitId);
    const inventoryUnitIdsArray = encodeURIComponent(JSON.stringify(inventoryUnitIds))
    const rentalPeriods = await asyncPaginatedFetch(`${this.API_BASE_URL}/rental_periods?inventories=${inventoryUnitIdsArray}&date=${date}`);

    return rentalPeriods.map(rentalPeriod => RentalPeriod.fromAttributes(rentalPeriod));
  }

  async fetchLandmarks() {
    const landmarks = await asyncPaginatedFetch(`${this.API_BASE_URL}/landmarks?layout_id=${this.layoutId}`);
    return landmarks.map(landmark => Landmark.fromAttributes(landmark));
  }

  async fetchLayoutProducts() {
    const params = new URLSearchParams({ layout_id: this.layoutId, destination_id: this.destinationId });
    if (!this.layoutId) params.delete('layout_id');
    const products = await asyncFetchData(`${this.API_BASE_URL}/layout_products?${params}`);
    return products.map(product => LayoutProduct.fromAttributes(product));
  }

  async fetchSections() {
    const sections = await asyncFetchData(`${this.API_BASE_URL}/layout_sections?layout_id=${this.layoutId}`);
    return sections.map(section => LayoutSection.fromAttributes(section));
  }

  async saveLayout(positions, landmarks, sections) {
    const positionsWithSections = filter(positions, 'sectionId');
    const positionsWithoutSections = difference(positions, positionsWithSections);
    const sectionSerializer = new LayoutSectionSerializer(positionsWithSections);
    const data = {
      layout_positions_attributes: positionsWithoutSections.map(position => position.serialize()),
      landmarks_attributes: landmarks.map(landmark => landmark.serialize()),
      layout_id: this.layoutId,
      sections: sections.map(section => sectionSerializer.serialize(section)),
      destination_id: this.destinationId
    }
    let layout = null;
    const { response, error } = await this.postData(`${this.API_BASE_URL}/layouts`, data);
    if (response) layout = Layout.fromAttributes(response);
    return { layout, error };
  }

  async postData(url, payload) {
    const headers = {
      'Content-Type': 'application/json',
      'X-CSRF-Token': this.token
    }
    try {
      const response = await fetch(url, { method: 'POST', body: JSON.stringify(payload), headers: headers });
      if (response.status === 422) return { response: null, error: await response.json() };
      return { response: await response.json(), error: null };
    } catch (e) {
      console.error(e)
      return {};
    }
  }

  async fetchData(url) {
    try {
      const response = await fetch(url);
      return response.json();
    } catch (err) {
      console.error(err);
      return [];
    }
  }

}
